<script>
  import MojLogo from "$assets/icons/Logo_512.png";
  import config from "@/config";
  import { FEED_BLOCK_NUDGE, INSTALL_REFERRER } from "@/constants/constants";
  import constants from "@/constants/index";
  import trackEvents from "@/events";
  import EVENTS from "@/events/events";
  import profileStore from "@/stores/profile";
  import * as utils from "@/utils/helpers/utils";
  import * as PropTypes from "prop-types";
  import { onMount } from "svelte";

  const { downloadAppUrl } = config;
  const { checkPropTypes, string } = PropTypes;
  export let intentUrl;
  export let visible = "";
  export let toggleInstallBanner;
  const propTypes = {
    intentUrl: string,
    source: string,
  };

  let isAppIntentSupported = false;

  const handleInstall = () => {
    trackEvents("DownloadAppButton", {
      source: "static-install-banner",
    });
  };

  const handleScreenClick = () => {
    trackEvents(EVENTS.PWA_STATIC_INSTALL_CLICK, {
      variant: "pwa_popup_variant-2",
      type: FEED_BLOCK_NUDGE.HARD_FULLSCREEN,
      position: 1,
    });
    window.open(
      isAppIntentSupported
        ? `${utils.ANDROID_APP_INTENT(
            intentUrl,
            `${$profileStore.userId}_${INSTALL_REFERRER.STATIC_INSTALL_BANNER}`,
            $profileStore.deviceId
          )}`
        : downloadAppUrl,
      isAppIntentSupported ? "" : "blank" // <- This is what makes it open in a new window.
    );
  };

  $: if (visible) {
    toggleInstallBanner(false);
    trackEvents(EVENTS.PWA_STATIC_INSTALL_VIEW, {
      variant: "pwa_popup_variant-2",
      type: FEED_BLOCK_NUDGE.HARD_FULLSCREEN,
      position: 1,
    });
  }

  onMount(() => {
    isAppIntentSupported = utils.isAndroid();
    checkPropTypes(propTypes, $$props, "prop", "InstallBanner");
  });
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="relative h-full" on:click={handleScreenClick}>
  <img
    class="rounded-2xl z-[1000] h-full w-full"
    alt="static-banner"
    src={constants.STATIC_BANNER}
  />
  <div class="absolute install-banner">
    <img src={MojLogo} alt="MojLogo" class="w-6xl" />
    <div class=" text-white text-mmd m-xs font-button w-full">
      Get the full app experience
    </div>
    <div class="Fz($caption2) Fw($subTitle) mb-md">
      You have exhausted your daily limit. Download the app to and keep sharing
      the joy
    </div>
    <div
      class={`rounded-lg bg-[#ffcd0a] px-xs py-xls text-black w-full cta-text`}
      on:click={handleInstall}
    >
      Get the Moj app
    </div>
  </div>
</div>

<style>
  .bottom-banner {
    height: max(50px, 10vh);
  }
  .bottom-banner2 {
    height: 50px;
  }
  .install-banner {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 85%;
    text-align: center;
    color: white;
  }
  .cta-text {
    font-size: 15px;
    font-weight: 700;
  }
</style>
